import { useRef, useCallback } from 'react'
import { MapCameraChangedEvent } from '@vis.gl/react-google-maps'

const useMapPosition = () => {
  const cameraRef = useRef({
    zoom: 8,
    center: { lat: 52.22977, lng: 21.01178 },
  })

  const handleCameraChanged = useCallback((event: MapCameraChangedEvent) => {
    const { zoom, center } = event.detail

    cameraRef.current = { zoom, center }
  }, [])

  return { cameraRef, handleCameraChanged }
}

export default useMapPosition
